import { Controller, FieldValues, Path, PathValue } from 'react-hook-form'

import { Select, Textfield } from '@clientbase/clientbase-library'
import { Grid, MenuItem } from '@mui/material'

import { DatePicker } from 'components/DatePicker'

import { daysDueDate } from '../Discounts/Discounts.utils'
import { ExpirationSettingsProps } from './ExpirationSettings.interface'

const ExpirationSettings = <T extends FieldValues>({
  control,
  isCharge,
  edit,
  setValue,
  dueDay
}: ExpirationSettingsProps<T>) => {
  return (
    <Grid container={true} mt={0} spacing={2}>
      <Grid item={true} xs={12}>
        {!(edit && !isCharge) ? (
          <Controller
            control={control}
            name={'dueDate' as Path<T>}
            render={({
              field: { onChange, value, ref },
              fieldState: { error }
            }) => {
              return (
                <DatePicker
                  inputRef={ref}
                  helperText={error?.message}
                  error={!!error?.message}
                  label={
                    isCharge
                      ? 'Qual a data de vencimento?'
                      : 'Qual o vencimento do primeiro ciclo?'
                  }
                  minDate={new Date()}
                  maxDate={
                    new Date(
                      new Date().setFullYear(new Date().getFullYear() + 10)
                    )
                  }
                  onChange={(newValue) => {
                    onChange(newValue)
                    setValue(
                      'dueDate' as Path<T>,
                      newValue as PathValue<T, Path<T>>
                    )
                  }}
                  renderInput={(props: any) => (
                    <Textfield {...props} name="dueDate" />
                  )}
                  toolbarPlaceholder="Escolha a data de vencimento"
                  value={value || null}
                />
              )
            }}
          />
        ) : (
          <Controller
            control={control}
            name={'dueDay' as Path<T>}
            render={({
              field: { onChange, value, ref },
              fieldState: { error }
            }) => {
              return (
                <Select
                  inputRef={ref}
                  helperText={error?.message}
                  error={!!error?.message}
                  fullWidth={true}
                  label="Informe o dia de vencimento da recorrência:"
                  name="dueDay"
                  onChange={(e) => {
                    const newValue = e.target.value
                    onChange(newValue)
                    setValue(
                      'dueDay' as Path<T>,
                      newValue as PathValue<T, Path<T>>
                    )
                  }}
                  value={value ?? dueDay}
                >
                  {daysDueDate.map(({ label, value }, index) => (
                    <MenuItem key={index} value={value}>
                      {label}
                    </MenuItem>
                  ))}
                </Select>
              )
            }}
          />
        )}
      </Grid>
    </Grid>
  )
}

export default ExpirationSettings
